import React from "react";
import { Box, Stack, Typography, Card, CardContent, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import LoopVideoBlock from "../video/LoopVideoBlock";

/**
 * IssueCard - 매거진 이슈 카드 컴포넌트
 * @param {object} props
 * @param {object} props.issue - 이슈 데이터
 * @param {Function} props.onIssueClick - 이슈 클릭 핸들러
 * @param {Function} props.getVideoUrl - 비디오 URL 생성 함수
 * @param {Function} props.formatIssueDate - 이슈 날짜 포맷팅 함수
 * @param {boolean} props.isMobile - 모바일 여부
 */
const IssueCard = ({ issue, onIssueClick, getVideoUrl, formatIssueDate, isMobile }) => {
	const { t } = useTranslation();
	const isPublished = issue.isPublished;

    return (
        <Card
            elevation={0}
            sx={{
                height: "100%",
                cursor: isPublished ? "pointer" : "not-allowed",
                border: 0,
                boxShadow: "none",
                backgroundColor: "transparent",
                opacity: isPublished ? 1 : 0.7,
                position: "relative",
            }}
            onClick={() => onIssueClick(issue)}
        >
			{/* 비디오 썸네일 */}
			<Box sx={{ position: "relative", paddingTop: "100%" }}>
				<Box
					sx={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
					}}
				>
					<LoopVideoBlock
						videoUrl={getVideoUrl(issue.id)}
						aspectRatio="1 / 1"
						width="100%"
						borderRadius={0}
						isMobile={isMobile}
						enableHover={false}
						showError={false}
						playOnHover={false}
					/>
				</Box>
			</Box>

			<CardContent>
				<Stack spacing={2}>
					<Stack spacing={0}>
						<Typography
							variant="h6"
							fontWeight={800}
							sx={{
								overflow: "hidden",
								textOverflow: "ellipsis",
								display: "-webkit-box",
								WebkitLineClamp: 2,
								WebkitBoxOrient: "vertical",
							}}
						>
							{issue.title || formatIssueDate(issue.id)}
						</Typography>
						{/* 이슈 날짜 - 제목 아래 작은 글씨 */}
						<Typography
							variant="body"
							color="text.secondary"
							fontWeight={500}
						>
							{formatIssueDate(issue.id)}
						</Typography>
					</Stack>
					{issue.description && (
						<Typography
							variant="body2"
							color="text.secondary"
							sx={{
								overflow: "hidden",
								textOverflow: "ellipsis",
								display: "-webkit-box",
								WebkitLineClamp: 3,
								WebkitBoxOrient: "vertical",
							}}
						>
							{issue.description}
						</Typography>
					)}
					{/* 참가자수 또는 곧 공개 예정 표시 */}
					{isPublished ? (
						<Typography variant="caption" color="text.secondary">
							{t("magazine.participantsCount", {
								count: Array.isArray(issue.userIdList)
									? issue.userIdList.length
									: 0,
							})}
						</Typography>
					) : (
						<Chip
							label={t("magazine.comingSoon", "곧 공개 예정")}
							color="primary"
							variant="filled"
							size="small"
							sx={{
								fontWeight: 600,
								fontSize: "0.75rem",
								alignSelf: "flex-start",
							}}
						/>
					)}
				</Stack>
			</CardContent>
		</Card>
	);
};

export default IssueCard;
